"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = require("axios");
var ALWAYS_ALLOWED = ["cookie-info"];
var AcceptedCookiesStrategy = /** @class */ (function () {
    function AcceptedCookiesStrategy(INTERNAL_API_URL, VERSION_FILES_JS) {
        this.INTERNAL_API_URL = INTERNAL_API_URL;
        this.VERSION_FILES_JS = VERSION_FILES_JS;
    }
    AcceptedCookiesStrategy.prototype.IsAllowed = function (cookieName, acceptedCookies) {
        var allowedCookies = acceptedCookies || this.Get();
        if (!allowedCookies || ALWAYS_ALLOWED.includes(cookieName.trim())) {
            return true;
        }
        return !!allowedCookies.find(function (cookie) { return (cookie.RegexName
            ? !!(new RegExp(cookie.Name).exec(cookieName))
            : cookie.Name === cookieName); });
    };
    AcceptedCookiesStrategy.prototype.UpdateAcceptedCookies = function (acceptedCategories) {
        var _this = this;
        this.getCookiesDictionary()
            .then(function (response) {
            _this.saveCookiesDictionary(acceptedCategories, response);
            _this.setLastUpdate();
            _this.setLastVersion();
        });
    };
    AcceptedCookiesStrategy.prototype.getCookiesDictionary = function () {
        return axios_1.default.get(this.INTERNAL_API_URL + "/Cookies/Dictionary")
            .then(function (response) { return response.data; });
    };
    return AcceptedCookiesStrategy;
}());
exports.default = AcceptedCookiesStrategy;
//# sourceMappingURL=AcceptedCookiesStrategy.js.map